import React, { useEffect, useMemo, useRef, useState } from "react";
import { io } from "socket.io-client";
import { POLLS_API, getOrCreateAnonId, getRoomCodeFromQuery } from "./pollsApi";

export default function PollsRoomPage() {
    const roomCode = getRoomCodeFromQuery();
    const [active, setActive] = useState(null);
    const [results, setResults] = useState(null);
    const [status, setStatus] = useState("connecting");
    const [myChoice, setMyChoice] = useState(null);

    const anonId = useMemo(() => getOrCreateAnonId(), []);
    const socketRef = useRef(null);

    useEffect(() => {
        if (!roomCode) return;

        const s = io(POLLS_API, { transports: ["websocket"] });
        socketRef.current = s;

        s.on("connect", () => setStatus("ready"));
        s.on("disconnect", () => setStatus("connecting"));

        s.emit("joinRoom", { roomCode });

        s.on("activeQuestion", (q) => {
            setActive(q);
            setMyChoice(null);
        });

        s.on("results", (r) => setResults(r));

        return () => {
            s.disconnect();
            socketRef.current = null;
        };
    }, [roomCode]);

    function vote(choice) {
        if (!roomCode || !active || !socketRef.current) return;
        setMyChoice(choice);

        socketRef.current.emit("vote", {
            roomCode,
            questionId: active.id,
            choice,
            anonId,
            userAgent: navigator.userAgent,
        });
    }

    if (!roomCode) {
        return (
            <div style={{ padding: 24, color: "#fff", fontFamily: "system-ui" }}>
                <h2>RaceVision Voting</h2>
                <p>Fehlt Room-Code. Beispiel:</p>
                <code>/polls/room?code=gt3x-r1</code>
            </div>
        );
    }

    const total = results?.total ?? 0;
    const showResults = !!(active?.showResults || results?.show);

    return (
        <div style={{ padding: 24, color: "#fff", fontFamily: "system-ui", maxWidth: 980, margin: "0 auto" }}>
            <div style={{ padding: 18, borderRadius: 18, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                    <h2 style={{ margin: 0 }}>RaceVision Voting</h2>
                    <div style={{ opacity: 0.75 }}>{status === "ready" ? "online" : "verbinde..."}</div>
                </div>

                {!active ? (
                    <div style={{ marginTop: 10, opacity: 0.8 }}>Gerade ist kein Voting aktiv.</div>
                ) : (
                    <>
                        <div style={{ marginTop: 12, fontSize: 20, fontWeight: 800 }}>
                            {active.title}
                            {active.timestamp ? <span style={{ marginLeft: 10, opacity: 0.75 }}>({active.timestamp})</span> : null}
                        </div>

                        {active.mediaUrl ? (
                            <div style={{ marginTop: 12 }}>
                                <img
                                    src={active.mediaUrl}
                                    alt=""
                                    style={{ width: "100%", borderRadius: 16, border: "1px solid rgba(255,255,255,0.12)" }}
                                />
                            </div>
                        ) : null}

                        <div style={{ marginTop: 12, display: "grid", gap: 10 }}>
                            {active.options.map((opt) => (
                                <button
                                    key={opt}
                                    onClick={() => vote(opt)}
                                    style={{
                                        padding: "14px 16px",
                                        borderRadius: 14,
                                        border: "1px solid rgba(255,255,255,0.12)",
                                        background: myChoice === opt ? "rgba(228,254,60,0.18)" : "rgba(255,255,255,0.06)",
                                        color: "#fff",
                                        cursor: "pointer",
                                        textAlign: "left",
                                        fontSize: 16,
                                    }}
                                >
                                    {opt}
                                </button>
                            ))}
                        </div>

                        <div style={{ marginTop: 10, opacity: 0.75 }}>Votes: {total}{myChoice ? ` · deine Wahl: ${myChoice}` : ""}</div>

                        {showResults && results?.counts ? (
                            <div style={{ marginTop: 14 }}>
                                <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 8 }}>Ergebnis</div>
                                {active.options.map((opt) => {
                                    const c = results.counts?.[opt] || 0;
                                    const pct = total ? Math.round((c / total) * 100) : 0;
                                    return (
                                        <div key={opt} style={{ marginBottom: 10 }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                                                <span>{opt}</span><span style={{ opacity: 0.85 }}>{pct}% ({c})</span>
                                            </div>
                                            <div style={{ height: 12, borderRadius: 999, background: "rgba(255,255,255,0.08)", overflow: "hidden" }}>
                                                <div style={{ width: `${pct}%`, height: "100%", borderRadius: 999, background: "rgba(228,254,60,0.78)" }} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : null}
                    </>
                )}
            </div>
        </div>
    );
}